import { ClassNames } from "@emotion/react";
// import { makeStyles } from "@mui/material";
import NavBar from "./NavBar";

import React from "react";

import { Container, CssBaseline, Box } from "@mui/material";
import "react-toastify/dist/ReactToastify.css"; // import first
import { ToastContainer } from "react-toastify"; // then this

export default function Layout({ children }) {
  return (
    <>
      {/* <CssBaseline /> */}
      <ToastContainer position="top-center" />
      <NavBar />

      <Box
        sx={{
          pt: {
            xs: 3,
            sm: 8,
            md: 8,
            lg: 8,
          },
          pb: {
            xs: 2,
            sm: 10,
            md: 10,
            lg: 10,
          },
        }}
        className={ClassNames.page}
      >
        {children}
      </Box>
    </>
  );
}
